// extracted by mini-css-extract-plugin
export default {"container":"styles_container__vQFZf","open":"styles_open__tLHHI","header":"styles_header__a6wXP","title":"styles_title__GyRXC"};